import React from 'react';
import { Phone, Mail, ExternalLink } from 'lucide-react';
export function ContactFooter() {
  return <footer className="bg-[#1A1A1A] text-white py-20 px-6" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-start" data-id="element-27">
          {/* Brand & Auction Info */}
          <div className="flex flex-col justify-between h-full" data-id="element-28">
            <div className="mb-12" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/bFck38gvxuhrFv3WeugoiY/Stonebridge_logo_master_reversed_1.0.png" alt="Stonebridge Property Group" className="h-12 md:h-14 object-contain mb-8" data-id="element-30" />
              <p className="text-white/50 max-w-sm text-sm leading-relaxed" data-id="element-31">
                Premium commercial property solutions. Connecting people with
                property across Australia.
              </p>
            </div>

            <div className="space-y-8" data-id="element-32">
              <div className="border-l-2 border-[#87C4D8] pl-6" data-id="element-33">
                <p className="text-[#87C4D8] text-xs uppercase tracking-widest font-bold mb-2" data-id="element-34">
                  Auction Date
                </p>
                <p className="text-3xl font-light text-white mb-1" data-id="element-35">
                  Friday 27th March 2026
                </p>
                <p className="text-lg text-white/60" data-id="element-36">12:30pm (AEDT)</p>
              </div>

              <div className="border-l-2 border-[#87C4D8] pl-6" data-id="element-37">
                <p className="text-[#87C4D8] text-xs uppercase tracking-widest font-bold mb-2" data-id="element-38">
                  Location
                </p>
                <p className="text-xl font-light text-white" data-id="element-39">
                  On-Site: 401 Chapel Street, South Yarra
                </p>
              </div>
            </div>
          </div>

          {/* Contact Agents */}
          <div className="bg-white/5 p-10 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-40">
            <div className="flex items-center justify-between mb-8 pb-6 border-b border-white/10" data-id="element-41">
              <h3 className="text-2xl font-bold text-white" data-id="element-42">Enquiries</h3>
              <span className="px-3 py-1 bg-[#87C4D8]/10 text-[#87C4D8] text-xs font-bold uppercase tracking-wider rounded-full" data-id="element-43">
                Exclusive Agents
              </span>
            </div>

            <div className="space-y-8" data-id="element-44">
              {/* Agent 1 */}
              <div className="flex items-center gap-6 group" data-id="element-45">
                <div className="relative" data-id="element-46">
                  <img src="https://cdn.magicpatterns.com/uploads/b26uYCezvLo476UxShHk3b/Nic-Hage-round.png" alt="Nic Hage" className="w-20 h-20 rounded-full object-cover ring-2 ring-white/10 group-hover:ring-[#87C4D8] transition-all" data-id="element-47" />
                </div>
                <div data-id="element-48">
                  <p className="font-bold text-xl text-white mb-1" data-id="element-49">Nic Hage</p>
                  <p className="text-white/50 text-sm uppercase tracking-wider mb-3" data-id="element-50">
                    Partner
                  </p>
                  <div className="flex flex-col gap-2 text-sm text-[#87C4D8]" data-id="element-51">
                    <a href="tel:+61448782594" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-52">
                      <Phone className="w-4 h-4" data-id="element-53" /> +61 448 782 594
                    </a>
                    <a href="mailto:nhage@stonebridge.com.au" className="flex items-center gap-3 hover:text-white transition-colors" data-id="element-54">
                      <Mail className="w-4 h-4" data-id="element-55" /> nhage@stonebridge.com.au
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <button className="w-full mt-10 bg-[#87C4D8] hover:bg-[#7ab3c6] text-[#1A1A1A] font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-[1.02] flex items-center justify-center gap-3 shadow-lg shadow-[#87C4D8]/20" data-id="element-56">
              Request Information Memorandum
              <ExternalLink className="w-5 h-5" data-id="element-57" />
            </button>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 text-center md:text-left flex flex-col md:flex-row justify-between items-center text-white/30 text-xs" data-id="element-58">
          <p data-id="element-59">© 2026 Stonebridge Property Group. All rights reserved.</p>
          <p className="mt-2 md:mt-0" data-id="element-60">
            *Outline Indicative Only. Approximately.
          </p>
        </div>
      </div>
    </footer>;
}